/**
 * Asset Logs API
 * Handles all asset audit log-related API calls
 */
import apiClient from './apiClient';
import { AssetLog, AssetLogsListResponse, AssetLogAction } from '../types';

export interface AssetLogsQueryParams {
  asset_id?: number;
  action?: string;
  performed_by?: number;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}

export const assetLogsApi = {
  /**
   * Get all asset logs with optional filters
   */
  getLogs: async (params?: AssetLogsQueryParams): Promise<AssetLogsListResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.asset_id) queryParams.append('asset_id', params.asset_id.toString());
    if (params?.action) queryParams.append('action', params.action);
    if (params?.performed_by) queryParams.append('performed_by', params.performed_by.toString());
    if (params?.date_from) queryParams.append('date_from', params.date_from);
    if (params?.date_to) queryParams.append('date_to', params.date_to);
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.per_page) queryParams.append('per_page', params.per_page.toString());

    const query = queryParams.toString();
    return apiClient.get<AssetLogsListResponse>(`/asset-logs${query ? `?${query}` : ''}`);
  },

  /**
   * Get logs for a specific asset
   */
  getLogsForAsset: async (assetId: number): Promise<{ asset_id: number; logs: AssetLog[]; total: number }> => {
    return apiClient.get<{ asset_id: number; logs: AssetLog[]; total: number }>(`/asset-logs/asset/${assetId}`);
  },

  /**
   * Get available action types for filtering
   */
  getActionTypes: async (): Promise<{ actions: AssetLogAction[] }> => {
    return apiClient.get<{ actions: AssetLogAction[] }>('/asset-logs/actions');
  },

  /**
   * Get recent asset activity (last 7 days)
   */
  getRecentLogs: async (limit?: number): Promise<{ logs: AssetLog[]; total: number }> => {
    const queryParams = new URLSearchParams();
    if (limit) queryParams.append('limit', limit.toString());

    const query = queryParams.toString();
    return apiClient.get<{ logs: AssetLog[]; total: number }>(`/asset-logs/recent${query ? `?${query}` : ''}`);
  },
};

export default assetLogsApi;
